// extracted by mini-css-extract-plugin
var _1 = "TableLayout_free__7285b";
var _2 = "TableLayout_root__9e849";
export { _1 as "free", _2 as "root" }
